import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=7b073a15"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=7b073a15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports